module.exports = __webpack_public_path__ + "img/suqian.4a0f0d7f.png";